import { Fragment, useState } from "react"
import {
    Box,
    Button,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    styled
} from "@mui/material"
import { ChevronDown, Crown, Gift, Globe, HandshakeIcon, HelpCircle, Menu, MessageCircle, Smartphone, Target, Trash2, ChevronUp, Gamepad2, Dice1Icon as Dice, WalletCardsIcon as Cards, Joystick } from 'lucide-react'
// import Image from "next/image"
// import Link from "next/link"
import { Link } from "react-router-dom"
import gugo from '../assets/gugo.svg';
import bet from '../assets/bet.svg';
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../redux/authSlice";
import LanguageSelector from "./LanguageSelector";

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: '#1a2634',
    color: 'white',
    height: '100%',
    width: 300,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '20px',
}))

const PromoBanner = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(to right, #1e2f45, #1a2634)',
    margin: '16px',
    padding: '16px',
    borderRadius: '8px',
    position: 'relative',
    overflow: 'hidden',
}))

const AppDownloadBanner = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(to right, #1976d2, #1565c0)',
    margin: '16px',
    padding: '16px',
    borderRadius: '8px',
}))

const SupportBanner = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(to right, #ed6c02, #9c27b0)',
    margin: '16px',
    padding: '16px',
    borderRadius: '8px',
}))

export default function MobileMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const [gamesExpanded, setGamesExpanded] = useState(false);
    const dispatch = useDispatch();
    const openLang = useSelector(state => state.auth.openLanguage);
    const toggleDrawer = (open) => (event) => {
        if (
            event.type === 'keydown' &&
            ((event).key === 'Tab' || (event).key === 'Shift')
        ) {
            return
        }
        setIsOpen(open)
    }

    const menuItems = [
        { text: 'Promotions', icon: <Gift size={20} />, link: '/promotions' },
        { text: 'Bonus', icon: <Gift size={20} />, link: '/bonus' },
        { text: 'Lucky Spin', icon: <Target size={20} />, link: '/lucky-spin' },
        {
            text: 'All Games',
            icon: <Crown size={20} />,
            expandable: true,
            subItems: [
                { text: 'Sports', icon: <Gamepad2 size={20} />, link: '/games/sports' },
                { text: 'Casino', icon: <Dice size={20} />, link: '/games/casino' },
                { text: 'Table Games', icon: <Cards size={20} />, link: '/games/table' },
                { text: 'Mini Games', icon: <Joystick size={20} />, link: '/games/mini' },
            ],
        },
        { text: 'Online Betting Blog', icon: <MessageCircle size={20} />, link: '/blog' },
        { text: 'Join Partner', icon: <HandshakeIcon size={20} />, link: '/partner' },
        { text: 'Sponsor', icon: <Target size={20} />, link: '/sponsor' },
        { text: 'Clear Cache', icon: <Trash2 size={20} />, action: () => console.info('Clear cache') },
    ]

    const onClickLangSelector = () => {
        dispatch(updateAuth({ openLanguage: true }))
    }

    return (
        <>
            <Button
                onClick={toggleDrawer(true)}
                sx={{ color: 'white', minWidth: 'auto' }}
            >
                <Menu size={24} />
            </Button>
            <Drawer
                anchor="left"
                open={isOpen}
                onClose={toggleDrawer(false)}
            >
                <StyledBox role="presentation">
                    <Box className='px-2 py-4' sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <button onClick={toggleDrawer(false)}>
                            <Close />
                        </button>
                        <Link href="/" onClick={toggleDrawer(false)}>
                            <div className='flex'>
                                <img src={gugo} width={60} alt="" />
                                <img src={bet} width={38} alt="" />
                            </div>
                        </Link>
                    </Box>
                    <Box sx={{ flexGrow: 1, overflowY: 'auto', paddingBottom: '20px' }} className='hidden-scrollbar'>
                        <PromoBanner>
                            <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold' }}>
                                Invite Friends Christmas
                            </Typography>
                            <Typography variant="subtitle2" sx={{ color: '#ffd700' }}>
                                Get ₹50 Bonus + Cashback
                            </Typography>
                            <Box sx={{ position: 'absolute', bottom: 0, right: 0 }}>
                                <img src="/placeholder.svg" alt="Promo" width={80} height={80} style={{ opacity: 0.5 }} />
                            </Box>
                        </PromoBanner>

                        <List>
                            {menuItems.map((item) => (
                                <Fragment key={item.text}>
                                    <ListItem disablePadding>
                                        {item.link ? (
                                            <Link
                                                href={item.link}
                                                style={{ width: '100%', textDecoration: 'none', color: 'inherit' }}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemButton>
                                                    <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
                                                        {item.icon}
                                                    </ListItemIcon>
                                                    <ListItemText primary={item.text} />
                                                </ListItemButton>
                                            </Link>
                                        ) : item.expandable ? (
                                            <ListItemButton onClick={() => setGamesExpanded(!gamesExpanded)}>
                                                <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
                                                    {item.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={item.text} />
                                                {gamesExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                            </ListItemButton>
                                        ) : (
                                            <ListItemButton onClick={item.action}>
                                                <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
                                                    {item.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={item.text} />
                                            </ListItemButton>
                                        )}
                                    </ListItem>
                                    {item.expandable && gamesExpanded && (
                                        <List component="div" disablePadding>
                                            {item.subItems.map((subItem) => (
                                                <Link
                                                    key={subItem.text}
                                                    href={subItem.link}
                                                    style={{ width: '100%', textDecoration: 'none', color: 'inherit' }}
                                                    onClick={toggleDrawer(false)}
                                                >
                                                    <ListItemButton sx={{ pl: 4 }}>
                                                        <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
                                                            {subItem.icon}
                                                        </ListItemIcon>
                                                        <ListItemText primary={subItem.text} />
                                                    </ListItemButton>
                                                </Link>
                                            ))}
                                        </List>
                                    )}
                                </Fragment>
                            ))}
                        </List>

                        <Box sx={{ mt: 'auto' }}>
                            <AppDownloadBanner>
                                <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    App Download
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Smartphone size={20} />
                                    <Typography variant="body2">
                                        Install App to get discount.
                                    </Typography>
                                </Box>
                            </AppDownloadBanner>
                        </Box>

                        <SupportBanner>
                            <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                Customer Support
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <HelpCircle size={20} />
                                <Typography variant="body2">24/7 Online</Typography>
                            </Box>
                        </SupportBanner>
                        <button className="flex items-center gap-1 float-end rounded-md bg-[#1c2d44] px-3 py-[6px] mr-4"
                            onClick={onClickLangSelector}>
                            <Globe size={20} />
                            <Typography>EN</Typography>
                        </button>
                    </Box>
                </StyledBox>
            </Drawer>
            {openLang && <LanguageSelector />}
        </>
    )
}

